module.exports = __webpack_public_path__ + "st.abdc5603.svg";